import React from 'react'
import { Component, Flex, Box, Button, Text, Icon } from 'components'

const ShareIcon = Box.withComponent(Icon).extend`
  vertical-align: middle;
  transform: translateY(-2px);
`

const LinkButton = Button.withComponent('a')

const getCurrentURL = () => `${window.location.protocol}//${window.location.hostname}${window.location.pathname}`

class Share extends Component {
  constructor () {
    super()
    this.state = { url: '' }
  }
  getUrlFromWindow () {
    this.setState({ url: getCurrentURL() })
  }
  componentDidMount () {
    this.getUrlFromWindow()
  }
  render () {
    const { title, hashtags='' } = this.props
    const url = this.state.url
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`
    const twitterUrl = `https://twitter.com/intent/tweet?hashtags=${hashtags.join(', ')}&original_referer=${url}&text=${title}&url=${url}`

    return (
      <Text textAlign="center" fontWeight="bold">
        <Box py={4} color="gray.2" bg="gray.6">
          {title}
        </Box>
        <Flex>
          <LinkButton href={twitterUrl} color="white" target="_blank" w={1/2} py={4} bg="brand.twitter">
            <ShareIcon mr={2} name="twitter" size="24px" />
            Tweet
          </LinkButton>
          <LinkButton href={facebookUrl} color="white" target="_blank" w={1/2} py={4} bg="brand.facebook">
            <ShareIcon mr={2} name="facebook" size="24px" />
            Post
          </LinkButton>
        </Flex>
      </Text>
    )
  }
}

export default Share



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Share.js